<template>
  <div>

    <!--    일반정보 -->
    <vs-card class="group-header">
      <h5 class="title">일반정보</h5>
    </vs-card>
    <vx-card class="mb-12">

      <vs-row class=" w-full mb-4">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">DB 테이블 이름(영문)</vs-col>
          <vs-col vs-type="flex" vs-align="center">
            <vs-col class="w-5/12 pr-4"><vs-input class="w-full" v-model="board_slug"></vs-input></vs-col>
            <vs-col class="w-5/12 hint">영문,숫자만 입력 가능 (공백없이)</vs-col>
          </vs-col>
        </vs-col>
      </vs-row>

      <vs-row class=" w-full mb-4">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">게시판 제목(국문)</vs-col>
          <vs-col vs-type="flex" vs-align="center">
            <vs-col class="w-5/12 pr-4"><vs-input class="w-full" v-model="board_title"></vs-input></vs-col>
          </vs-col>
        </vs-col>
      </vs-row>
    </vx-card>


    <!--    등급설정 -->
    <!--
    <vs-card class="group-header">
      <h5 class="title">등급설정</h5>
      <p class="hint">게시판의 권한설정보다 회원 권한 그룹 설정의 상세 권한이 우선적용됩니다.</p>
    </vs-card>
    <vx-card class="mb-12">

      <vs-row class=" w-full mb-4">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">게시판 관리자</vs-col>
          <vs-col vs-type="flex" vs-align="center">
            <vs-col class="w-5/12 pr-4"><vs-input class="w-full"></vs-input></vs-col>
            <vs-col class="w-5/12 hint">관리자 ID, 사용자명 검색 (//주석// 인스턴트검색)</vs-col>
          </vs-col>
        </vs-col>
      </vs-row>

      <vs-row class=" w-full">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">권한관리</vs-col>
          <vs-col vs-type="flex-wrap"  vs-align="center">

            <vs-col class="w-1/4 mb-4" vs-type="flex" vs-align="center">
              <vs-col class="w-1/3">목록보기</vs-col>
              <vs-col class="w-2/3"><vs-input class="w-10/12"></vs-input></vs-col>
            </vs-col>

            <vs-col class="w-1/4 mb-4" vs-type="flex" vs-align="center">
              <vs-col class="w-1/3">글읽기</vs-col>
              <vs-col class="w-2/3"><vs-input class="w-10/12"></vs-input></vs-col>
            </vs-col>

            <vs-col class="w-1/4 mb-4" vs-type="flex" vs-align="center">
              <vs-col class="w-1/3">글쓰기</vs-col>
              <vs-col class="w-2/3"><vs-input class="w-10/12"></vs-input></vs-col>
            </vs-col>

            <vs-col class="w-1/4 mb-4" vs-type="flex" vs-align="center">
              <vs-col class="w-1/3">답글쓰기</vs-col>
              <vs-col class="w-2/3"><vs-input class="w-10/12"></vs-input></vs-col>
            </vs-col>

            <vs-col class="w-1/4 mb-4" vs-type="flex" vs-align="center">
              <vs-col class="w-1/3">코멘트 쓰기</vs-col>
              <vs-col class="w-2/3"><vs-input class="w-10/12"></vs-input></vs-col>
            </vs-col>

            <vs-col class="w-1/4 mb-4" vs-type="flex" vs-align="center">
              <vs-col class="w-1/3">링크</vs-col>
              <vs-col class="w-2/3"><vs-input class="w-10/12"></vs-input></vs-col>
            </vs-col>

            <vs-col class="w-1/4 mb-4" vs-type="flex" vs-align="center">
              <vs-col class="w-1/3">다운로드 권한</vs-col>
              <vs-col class="w-2/3"><vs-input class="w-10/12"></vs-input></vs-col>
            </vs-col>

            <vs-col class="w-1/4 mb-4" vs-type="flex" vs-align="center">
              <vs-col class="w-1/3">HTML 쓰기 권한</vs-col>
              <vs-col class="w-2/3"><vs-input class="w-10/12"></vs-input></vs-col>
            </vs-col>

          </vs-col>
        </vs-col>
      </vs-row>

      <vs-row class=" w-full mb-4">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">메일발송</vs-col>
          <vs-col vs-type="flex" vs-align="center">
            <vs-col class="w-5/12 pr-4"><vs-input class="w-full"></vs-input></vs-col>
            <vs-col class="w-7/12 hint">
              게시판의 다음의 활동시 자동메일 발송 대상 기입, 회원 ID 기입, 쉼표로 분리 : 새글등록, 답글등록, 댓글등록 및 삭제
            </vs-col>
          </vs-col>
        </vs-col>
      </vs-row>

    </vx-card>
    -->

    <!--    리스트 옵션 -->
    <vs-card class="group-header">
      <h5 class="title">리스트 옵션</h5>
    </vs-card>
    <vx-card class="mb-12">
      <vs-row class=" w-full mb-4">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">제목 길이 조정</vs-col>
          <vs-col vs-type="flex" vs-align="center">
            <vs-col class="w-3/12 pr-4"><vs-input class="w-full" v-model="board_list_title_length"></vs-input> </vs-col>
            <vs-col class="w-3/12 hint">이하</vs-col>
          </vs-col>
        </vs-col>
      </vs-row>

      <vs-row class=" w-full mb-4">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">기본목록 개수</vs-col>
          <vs-col vs-type="flex" vs-align="center">
            <vs-col class="w-3/12 pr-4"><vs-input class="w-full" v-model="board_list_size"></vs-input> </vs-col>
            <vs-col class="w-3/12 hint">개</vs-col>
          </vs-col>
        </vs-col>
      </vs-row>

      <vs-row class=" w-full mb-4 py-2">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">댓글 정렬</vs-col>
          <vs-col vs-type="flex" vs-align="center">
            <vs-radio class="mr-10" v-model="board_comment_order_id" vs-value="board_comment_order_id:1">최신순</vs-radio>
            <vs-radio class="mr-10" v-model="board_comment_order_id" vs-value="board_comment_order_id:2">오래된순</vs-radio>
            <vs-radio v-model="board_comment_order_id" vs-value="board_comment_order_id:3">조회순</vs-radio>
          </vs-col>
        </vs-col>
      </vs-row>

      <vs-row class=" w-full mb-4 py-2">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">리스트 정렬</vs-col>
          <vs-col vs-type="flex" vs-align="center">
            <vs-radio class="mr-10" v-model="board_list_order_id" vs-value="board_list_order_id:1">최신순</vs-radio>
            <vs-radio v-model="board_list_order_id" vs-value="board_list_order_id:2">오래된순</vs-radio>
          </vs-col>
        </vs-col>
      </vs-row>

    </vx-card>


    <!--    글쓰기 옵션 -->
    <vs-card class="group-header">
      <h5 class="title">글쓰기 옵션</h5>
    </vs-card>
    <vx-card class="mb-12">
      <vs-row class=" w-full mb-4 py-2">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">비밀글 옵션</vs-col>
          <vs-col vs-align="center">
            <vs-switch v-model="board_use_secret_write" style="width:54px">
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
          </vs-col>
        </vs-col>
      </vs-row>

      <vs-row class=" w-full mb-4 py-2">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">HTML 에디터 사용</vs-col>
          <vs-col vs-align="center">
            <vs-switch v-model="board_use_html_write" style="width:54px">
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
          </vs-col>
        </vs-col>
      </vs-row>

      <vs-row class=" w-full mb-4 py-2">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">글요약 입력 사용</vs-col>
          <vs-col vs-align="center">
            <vs-switch v-model="board_use_summary_write" style="width:54px">
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
          </vs-col>
        </vs-col>
      </vs-row>

      <vs-row class=" w-full mb-4 py-2">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">글쓴이 표시옵션</vs-col>
          <vs-col vs-type="flex" vs-align="center">
            <vs-radio class="mr-10" v-model="board_author_display_type_id" vs-value="board_author_display_type_id:1">아이디</vs-radio>
            <vs-radio class="mr-10" v-model="board_author_display_type_id" vs-value="board_author_display_type_id:2">실명</vs-radio>
            <vs-radio v-model="board_author_display_type_id" vs-value="board_author_display_type_id:3">사용자명</vs-radio>
          </vs-col>
        </vs-col>
      </vs-row>

      <vs-row class=" w-full mb-4 ">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">제목 글자수 제한</vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-justify="left">
            <vs-col class="fix-number-input " vs-type="flex" vs-align="center">
              <vs-input class="w-3/4 pr-2" v-model="board_title_length_min"></vs-input>
              <label class="w-1/4">초과</label>
            </vs-col>
            <vs-col class="fix-wavedash pr-2" vs-type="flex" vs-align="center" vs-justify="center">
              <b>~</b>
            </vs-col>
            <vs-col class="fix-number-input " vs-type="flex" vs-align="center">
              <vs-input class="w-3/4 pr-2" v-model="board_title_length_max"></vs-input>
              <label class="w-1/4">미만</label>
            </vs-col>
          </vs-col>
        </vs-col>
      </vs-row>

      <vs-row class=" w-full mb-4 ">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">댓글 글자수 제한</vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-justify="left">
            <vs-col class="fix-number-input " vs-type="flex" vs-align="center">
              <vs-input class="w-3/4 pr-2" v-model="board_comment_length_min"></vs-input>
              <label class="w-1/4">초과</label>
            </vs-col>
            <vs-col class="fix-wavedash pr-2" vs-type="flex" vs-align="center" vs-justify="center">
              <b>~</b>
            </vs-col>
            <vs-col class="fix-number-input " vs-type="flex" vs-align="center">
              <vs-input class="w-3/4 pr-2" v-model="board_comment_length_max"></vs-input>
              <label class="w-1/4">미만</label>
            </vs-col>
          </vs-col>
        </vs-col>
      </vs-row>

      <vs-row class=" w-full mb-4 ">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">첨부파일 허용개수</vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-justify="left">
            <vs-col class="fix-number-input " vs-type="flex" vs-align="center">
              <vs-input class="w-3/4 pr-2" v-model="board_attachment_max_count"></vs-input>
              <label class="w-1/4">개</label>
            </vs-col>
          </vs-col>
        </vs-col>
      </vs-row>

      <vs-row class=" w-full mb-4 ">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">첨부파일 허용 용량</vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-justify="left">
            <vs-col class="fix-number-input-90 " vs-type="flex" vs-align="center">
              <vs-input class="pr-2" v-model="board_attachment_max_mb"></vs-input>
            </vs-col>
            <vs-col >
              <label class="hint">bytes 이하 (최대 10M 이하) 1MB = 1,024,768 bytes</label>
            </vs-col>
          </vs-col>
        </vs-col>
      </vs-row>

    </vx-card>


    <!--    글 보기 옵션 -->
    <vs-card class="group-header">
      <h5 class="title">글 보기 옵션</h5>
    </vs-card>
    <vx-card class="mb-12">
      <vs-row class="w-full py-2">
        <vs-checkbox class="mr-12" v-model="board_author_ip_display">글쓴이 IP 보이기</vs-checkbox>
        <vs-checkbox class="mr-12" v-model="board_use_reply">답글 사용 여부</vs-checkbox>
        <vs-checkbox v-model="board_use_comment">댓글 사용 여부</vs-checkbox>
      </vs-row>
    </vx-card>


    <!--    글 수정 옵션 -->
    <!--
    <vs-card class="group-header">
      <h5 class="title">글 수정 옵션</h5>
    </vs-card>
    <vx-card class="mb-12">

      <vs-row class=" w-full mb-4 ">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">원본 수정 불가</vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-justify="left">
            <vs-col class="fix-number-input-prev " vs-type="flex" vs-align="center">
              <label class="w-2/12">답글</label>
              <vs-input class="w-6/12 px-2"></vs-input>
              <label class="w-4/12">개 이상</label>
            </vs-col>
            <vs-col class="fix-wavedash pr-2" vs-type="flex" vs-align="center" vs-justify="center">
              <b>~</b>
            </vs-col>
            <vs-col class="fix-number-input-prev " vs-type="flex" vs-align="center">
              <label class="w-2/12">댓글</label>
              <vs-input class="w-6/12 px-2"></vs-input>
              <label class="w-4/12">개 이상</label>
            </vs-col>
          </vs-col>
        </vs-col>
      </vs-row>

      <vs-row class=" w-full mb-4 ">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">원본 삭제 불가</vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-justify="left">
            <vs-col class="fix-number-input-prev " vs-type="flex" vs-align="center">
              <label class="w-2/12">답글</label>
              <vs-input class="w-6/12 px-2"></vs-input>
              <label class="w-4/12">개 이상</label>
            </vs-col>
            <vs-col class="fix-wavedash pr-2" vs-type="flex" vs-align="center" vs-justify="center">
              <b>~</b>
            </vs-col>
            <vs-col class="fix-number-input-prev " vs-type="flex" vs-align="center">
              <label class="w-2/12">댓글</label>
              <vs-input class="w-6/12 px-2"></vs-input>
              <label class="w-4/12">개 이상</label>
            </vs-col>
          </vs-col>
        </vs-col>
      </vs-row>
    </vx-card>
    -->

    <!--    게시판 디자인 옵션 -->
    <vs-card class="group-header">
      <h5 class="title">게시판 디자인 옵션</h5>
    </vs-card>
    <vx-card class="mb-12">

      <vs-row class=" w-full mb-4 ">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">게시판 타입</vs-col>
          <vs-col>
            <vs-select autocomplete label="" v-model="selectBoardType">
              <vs-select-item :key="index" :value="item.type_code" :text="item.type_name"
                              v-for="(item,index) in boardTypes"/>
            </vs-select>
          </vs-col>
        </vs-col>
      </vs-row>

      <vs-row class=" w-full mb-4 ">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">스킨선택</vs-col>
          <vs-col>
            <vs-select autocomplete label="" >
              <vs-select-item value="value" text="일반"/>
              <vs-select-item value="value" text="갤러리"/>
            </vs-select>
          </vs-col>
        </vs-col>
      </vs-row>

      <vs-row class=" w-full mb-4 ">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">Header 파일 경로</vs-col>
          <vs-col> <vs-input class="w-full"></vs-input> </vs-col>
        </vs-col>
      </vs-row>

      <vs-row class=" w-full mb-4 ">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">Footer 파일 경로</vs-col>
          <vs-col> <vs-input class="w-full"></vs-input> </vs-col>
        </vs-col>
      </vs-row>

      <vs-row class=" w-full mb-4 ">
        <vs-col class="w-full" vs-type="flex" vs-align="center">
          <vs-col class="fix-title">글쓰기 템플릿</vs-col>
          <vs-col>
            <quill-editor class="vx-col flex-1 ql-edit-text" v-model="contentInput" :options="quillOption"></quill-editor>
          </vs-col>
        </vs-col>
      </vs-row>

      <vs-row class="mt-8" vs-justify="center">
        <vs-button class="large mr-4 " color="#EDEDED" text-color="black" type="filled" >취소</vs-button>
        <vs-button class="large" color="secondary" >저장</vs-button>
      </vs-row>
    </vx-card>

  </div>
</template>

<script>
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor'

export default {
  name: 'BoardUpdate',
  components: {
    // FileInput,
    quillEditor
  },
  data () {
    return {
      boardId:0,
      board_slug:'',
      board_title:'',
      board_list_title_length:'',
      board_list_size:'',
      board_list_order_id:'board_list_order_id:1',
      board_comment_order_id:'board_comment_order_id:1',
      board_use_secret_write:false,
      board_use_html_write:false,
      board_use_summary_write:false,
      board_author_display_type_id:'board_author_display_type_id:1',
      board_title_length_max:50,
      board_title_length_min:1,
      board_comment_length_max:200,
      board_comment_length_min:2,
      board_author_ip_display:false,
      board_use_reply:false,
      board_use_comment:false,

      selectBoardType:'normal',
      boardTypes: [{text:'일반게시판', value:'1'}, {text:'갤러리', value:'2'}],
      itemsPerPage:'',
      secret:false,
      useHTMLEditer:false,
      summary:false,
      comment_sort:'comment_sort_desc',
      list_sort:'list_sort_desc',
      writer_mode:'username',
      radios_A:'desc',
      quillOption: {
        placeholder: '내용을 입력해주세요 ...'
      },
      contentInput:'',

      board_attachment_max_count:0,
      board_attachment_max_mb:0
    }
  },

  created () {

    this.boardId = this.$route.params.id
    this.loadBoardType()
  },
  methods : {
    async loadBoardType () {
      await this.$store.dispatch('board/LOAD_BOARD_TYPE_LIST')
      this.boardTypes = this.$store.state.board.types
    }
  }
}
</script>

<style >
</style>

<style scoped>
.hint { color : #727272; font-size:12px }
.large { width:150px; }

.fix-title { width:180px !important; }
.fix-wavedash { width:30px !important; }
.fix-number-input { width:120px !important; }
.fix-number-input-90 { width: 90px !important; }
.fix-number-input-prev { width:180px !important; }
.group-header { margin-bottom:15px; padding:11px }
.group-header .vs-card--content { display: flex; margin-bottom:0px; }
.group-header .hint { margin-left:16px; }
.ql-edit-text .ql-editor {
  overflow-y: scroll;
  resize: vertical;
  min-height: 20em;
}
</style>
